import { render, staticRenderFns } from "./settings.page.vue?vue&type=template&id=d971cb98&scoped=true&"
import script from "./settings.page.vue?vue&type=script&lang=js&"
export * from "./settings.page.vue?vue&type=script&lang=js&"
import style0 from "./settings.page.vue?vue&type=style&index=0&id=d971cb98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d971cb98",
  null
  
)

export default component.exports